import { render, staticRenderFns } from "./Accordion-item.vue?vue&type=template&id=6736f9b3&scoped=true"
import script from "./Accordion-item.vue?vue&type=script&lang=js"
export * from "./Accordion-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6736f9b3",
  null
  
)

export default component.exports